import Notification from './src/main.js';
export default Notification;



// WEBPACK FOOTER //
// ./packages/notification/index.js